var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenedEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.9095 9.17176C1.56793 8.42865 1.56793 7.57136 1.9095 6.82824C3.4906 3.38843 6.96659 1 11.0004 1C15.0343 1 18.5102 3.38843 20.0913 6.82824C20.4329 7.57136 20.4329 8.42865 20.0913 9.17176C18.5102 12.6116 15.0343 15 11.0004 15C6.96659 15 3.4906 12.6116 1.9095 9.17176Z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0004 8C14.0004 9.65685 12.6573 11 11.0004 11C9.34357 11 8.00042 9.65685 8.00042 8C8.00042 6.34315 9.34357 5 11.0004 5C12.6573 5 14.0004 6.34315 14.0004 8Z",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenedEye);
export default __webpack_public_path__ + "static/media/opened-eye.5b804dd170068ed72450d046cdf236f5.svg";
export { ForwardRef as ReactComponent };